<template>
    <nav class="customer-primary-nav">
        <!--        <v-app-bar flat app class="icon-menu">-->
        <!--            <v-app-bar-nav-icon-->
        <!--                class="grey&#45;&#45;text"-->
        <!--                @click="drawer = !drawer"-->
        <!--            ></v-app-bar-nav-icon>-->
        <!--            <v-spacer></v-spacer>-->

        <!--            <v-btn depressed class="pink white&#45;&#45;text" @click="logout" :color="COLOR.MAIN_COLOR">-->
        <!--                <span>Sign Out</span>-->
        <!--                <v-icon class="ml-2">exit_to_app</v-icon>-->
        <!--            </v-btn>-->
        <!--        </v-app-bar>-->

        <div class="icon-menu">
            <v-app-bar-nav-icon
                    class="grey--text font-16"
                    @click="drawer = !drawer"
            ></v-app-bar-nav-icon>
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn
                            icon
                            dark
                            class="float-right mr-2"
                            v-on="on"
                    >
                        <v-icon large>mdi-account-check</v-icon>
                    </v-btn>
                </template>
                <BoxMenu :flag="flag" :currentUser="currentUser"></BoxMenu>
            </v-menu>
            <!--            <v-text-field v-if="loadingData" class="loading" color="red" loading disabled></v-text-field>-->
        </div>

        <v-navigation-drawer app v-model="drawer" :color="COLOR.MAIN_COLOR" class="white--text">
            <v-layout column align-center>
                <v-flex class="mt-5">
                    <router-link to="/home">
                        <v-avatar size="100">
                            <img
                                    :src="logo"
                                    alt=""
                            />
                        </v-avatar>
                    </router-link>
                    <!--                    <h2 class="subheading mt-1 text-center orange&#45;&#45;text font-weight-bold" >-->
                    <!--                        Amai-->
                    <!--                    </h2>-->


                </v-flex>
            </v-layout>
            <v-card flat class="mx-auto menus" width="300">
                <v-list>
                    <v-list-item-group color="primary">

                        <template>
                            <v-list-group color="white" :value="true">
                                <template v-slot:activator>
                                    <v-list-item-icon>
                                        <v-icon>mdi-home</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title color="white" class="white--text">
                                        Trang Chủ
                                    </v-list-item-title>
                                </template>
                                
                                <template>
                                    
                                    <v-list-item sub-group router :to="{name: 'home'}">
                                        <v-list-item-icon sub-group class="ml-4">
                                            <v-icon small>mdi-home</v-icon>
                                        </v-list-item-icon>
                                        <div class="ml-n4">Trang Chủ</div>
                                    </v-list-item>

                                    <v-list-item sub-group router :to="{name: 'user.payment'}">
                                        <v-list-item-icon sub-group class="ml-4">
                                            <v-icon>mdi-currency-usd</v-icon>
                                        </v-list-item-icon>
                                        <div class="ml-n4">Nạp tiền</div>
                                    </v-list-item>

                                    <v-list-item sub-group router :to="{name: 'price.list'}">
                                        <v-list-item-icon sub-group class="ml-4">
                                            <v-icon>mdi-tooltip-text</v-icon>
                                        </v-list-item-icon>
                                        <div class="ml-n4">Bảng giá dịch vụ</div>
                                    </v-list-item>

                                    <v-list-item router :to="{name: 'support_site'}">
                                        <v-list-item-icon>
                                            <v-icon>mdi-headset</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>Tạo site riêng cho đại lý</v-list-item-title>
                                    </v-list-item>
                                    
                                    <v-list-item sub-group router :to="{name: 'ticket_list'}">
                                        <v-list-item-icon sub-group class="ml-4">
                                            <v-icon>mdi-account-question</v-icon>
                                        </v-list-item-icon>
                                        <div class="ml-n4">Hỗ trợ</div>
                                    </v-list-item>
                                    
                                </template>
                            </v-list-group>
                        </template>
                        
                        <!--<v-list-item router :to="{name: 'home'}">-->
                            <!--<v-list-item-icon>-->
                                <!--<v-icon>mdi-home</v-icon>-->
                            <!--</v-list-item-icon>-->
                            <!--<v-list-item-title>Trang Chủ</v-list-item-title>-->
                        <!--</v-list-item>-->
                        <!---->
                        <!--<v-list-item router :to="{name: 'user.payment'}">-->
                            <!--<v-list-item-icon>-->
                                <!--<v-icon>mdi-currency-usd</v-icon>-->
                            <!--</v-list-item-icon>-->
                            <!--<v-list-item-title>Nạp tiền</v-list-item-title>-->
                        <!--</v-list-item>-->
                        <!--<v-list-item router :to="{name: 'price.list'}">-->
                            <!--<v-list-item-icon>-->
                                <!--<v-icon>mdi-tooltip-text</v-icon>-->
                            <!--</v-list-item-icon>-->
                            <!--<v-list-item-title>Bảng giá dịch vụ</v-list-item-title>-->
                        <!--</v-list-item>-->

                        <!--<v-list-item router :to="{name: 'ticket_list'}">-->
                            <!--<v-list-item-icon>-->
                                <!--<v-icon>mdi-account-question</v-icon>-->
                            <!--</v-list-item-icon>-->
                            <!--<v-list-item-title>Hỗ trợ</v-list-item-title>-->
                        <!--</v-list-item>-->
                        
                        <template>
                            <v-list-group color="white" :value="false">
                                <template v-slot:activator>
                                    <v-list-item-icon>
                                        <v-icon>mdi-credit-card</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title color="white" class="white--text">
                                        Kiếm tiền
                                    </v-list-item-title>
                                </template>
                                <template>
                                    <v-list-item sub-group router :to="{name: 'referral'}">
                                        <v-list-item-icon sub-group class="ml-4">
                                            <v-icon small>mdi-account-group</v-icon>
                                        </v-list-item-icon>
                                        <div class="ml-n4">Giới thiệu</div>
                                    </v-list-item>
                                    <v-list-item sub-group router :to="{
                                            name: 'user_widthdraw',
                                            params : { type : 'process' }
                                        }"
                                                 v-bind:class="{
                                            'v-list-item--active'
                                            : $route.path == '/user-widthdraw/log'
                                        }">
                                        <v-list-item-icon sub-group class="ml-4">
                                            <v-icon small>mdi-currency-usd-circle</v-icon>
                                        </v-list-item-icon>
                                        <div class="ml-n4">Rút tiền</div>
                                    </v-list-item>
                                </template>
                            </v-list-group>
                        </template>

                        <template v-for="item in menu_seeding">
                            <v-list-group color="white" v-bind:key="item.vTitle"
                                          :value="false"
                            >
                                <!--                            :prepend-icon="item.prependIcon"-->
                                <template v-slot:activator>
                                    <v-list-item-icon>
                                        <v-icon>{{ item.prependIcon }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title color="white" class="white--text" :class="item.vClass">
                                        {{ item.vTitle }}
                                        <span class="buy_ip_hot" v-if="item.isHot">Hot</span>
                                    </v-list-item-title>

                                </template>

                                <template v-for="item1 in item.child">
                                    <a :href="item1.vTo" v-if="item1.outside" target="_blank" :key="item1.vTitle"
                                       class="v-list-item v-list-item--link theme--light" tabindex="0"
                                       sub-group="">
                                        <div sub-group="" class="v-list-item__icon ml-4">
                                            <i aria-hidden="true"
                                               class="v-icon notranslate mdi mdi-chevron-double-right theme--light"
                                               style="font-size: 16px;"></i>
                                        </div>
                                        <div class="ml-n4" v-html="item1.vTitle"></div>
                                    </a>
                                    <v-list-item
                                            v-bind:key="item1.vTitle"
                                            :to="item1.vTo"
                                            :class="item1.vClass"
                                            sub-group
                                            v-else
                                    >
                                        <v-list-item-icon sub-group class="ml-4">
                                            <v-icon small>{{ item1.vIcon }}</v-icon>
                                        </v-list-item-icon>
                                        <div class="ml-n4" v-html="item1.vTitle"></div>
                                    </v-list-item>
                                </template>
                            </v-list-group>
                        </template>
                        
                        <v-list-item router :to="{name: 'support'}">
                            <v-list-item-icon>
                                <v-icon>mdi-headset</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Liên hệ</v-list-item-title>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-card><!-- End  navigation-->
            <div class="box-menu-left">
                <!--                <BoxMenu :flag="flag" :currentUser="currentUser" :customCss="`mx-3`"></BoxMenu>-->
            </div>

        </v-navigation-drawer>
    </nav>
</template>

<script>
  import { MENU_MANAGE, MENU_SEEDING } from '~/config/navbar'
  import { AUTH_USER } from '~/store/actions.type'
  import { COLOR } from '~/config/constant'
  import BoxMenu from './BoxMenu'
  import $ from 'jquery'
  import { baseUrl, centralUrl } from '../config'
  import { CONFIG_PAGE } from '../store/actions.type'

  export default {
    name: 'navbar',
    components: {
      BoxMenu
    }
    ,
    data () {
      return {
        COLOR: COLOR,
        coin: 0,
        drawer: true,
        menu_manage: [],
        menu_seeding: [],
        default_avatar: 'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRb3cKuVSY5yQSumCbZVZJf05ere11Tt1sOSRrNYc425RBOUjS0',
        items: [
          { text: 'Thông Báo', icon: 'mdi-bell-ring-outline' },
        ],
        currentUser: {},
        flag: false,
        logo: '',
        appName: ''
      }
    },
    watch: {
      drawer () {
        console.log(this.drawer)
        if (this.drawer === false) {
          $('button.v-app-bar__nav-icon.grey--text.font-16.v-btn.v-btn--flat.v-btn--icon.v-btn--round.theme--light.v-size--default').css('margin-left', 'unset')
        } else {
          $('button.v-app-bar__nav-icon.grey--text.font-16.v-btn.v-btn--flat.v-btn--icon.v-btn--round.theme--light.v-size--default').css('margin-left', '256px')
        }
      }
    },
    methods: {
      logout () {
        this.$store.dispatch('auth_logout')
        this.$router.push('/login')
      },
      getDefaultAvatar () {
        this.$store.dispatch(CONFIG_PAGE).then((data) => {
          let logo = data.filter(o => o.key == 'key_cp_logo')
          if (logo[0]['value'] != undefined && logo[0]['status']) {
            this.logo = logo[0]['value']
          }
        })
      },
      async checkValidToken () {
        let result = await this.$store.dispatch(AUTH_USER)
        if (result !== false) {
          this.currentUser = result.data
          this.flag = true
        }
      },

      getAppName () {
        this.$store.dispatch(CONFIG_PAGE).then(data => {
          let appName = data.filter(o => o.key == 'key_cp_app_name')
          if (appName[0]['value'] != undefined && appName[0]['status']) {
            this.appName = appName[0]['value']
            localStorage.setItem('appName', this.appName)
          }
        })
      }
    },
    created () {
      this.menu_manage = MENU_MANAGE
      console.log(centralUrl, baseUrl)
      if (centralUrl == baseUrl) {
        this.menu_seeding = MENU_SEEDING
        console.log(this.menu_seeding)
      } else {
        MENU_SEEDING[0].child.pop()
        // MENU_SEEDING.pop();
        this.menu_seeding = MENU_SEEDING
        console.log(this.menu_seeding)
      }
      this.checkValidToken()
      this.getAppName()
    },
    mounted () {
      this.getDefaultAvatar()
      if (window.innerWidth <= 1263) {
        //this.drawer = true;
      }
    }
  }
</script>
<style lang="scss">
    @import "../scss/main";

    .icon-menu {
        button.v-app-bar__nav-icon.grey--text.font-16.v-btn.v-btn--flat.v-btn--icon.v-btn--round.theme--light.v-size--default {
            margin-left: 256px;
        }

        .v-icon {
            color: $mainColor !important;
        }

        .v-btn--icon.v-size--default .v-icon, .v-btn--fab.v-size--default .v-icon {
            font-size: 30px;
            margin-top: 3px;
        }
    }

    @media only screen and (max-width: 1263px) {
        .icon-menu {
            /*display: block;*/
            /*width: 35px;*/
            /*position: absolute;*/
            /*left: 0px;*/
            /*top: 7px;*/
            /*z-index: 1;*/

            button.v-app-bar__nav-icon.grey--text.font-16.v-btn.v-btn--flat.v-btn--icon.v-btn--round.theme--light.v-size--default {
                margin-left: unset;
            }
        }
        .box-menu-left {
            display: none;
        }
    }

    @media only screen and (max-width: 1263px) and (min-width: 768px) {
        main.v-content.py-sm-3.pr-sm-3 {
            padding-left: 12px !important;
        }
    }

    @media only screen and(max-width: 767px) {
        main.v-content.py-sm-3.pr-sm-3 {
            padding: 4px !important;
        }
    }

    .customer-primary-nav {
        .v-navigation-drawer {
            .menus {
                font-family: Arial;
                background: transparent !important;

                a {
                    color: #ffffff;
                }

                .v-list-group__header {
                    color: white !important;
                }

                .v-list-item:hover {
                    background: $clickMenuColor !important;
                    border-radius: 0 30px 30px 0 !important;
                    color: white !important;
                }

                .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
                    color: #ffffff !important;

                    .v-icon {
                        color: #ffffff !important;
                    }
                }

                .v-list-group__header.v-list-item--active {
                    //background: $clickMenuColor !important;
                    //border-radius: 0 30px 30px 0;
                    //color: white !important;
                }

                .theme--light.v-list-item--active {
                    color: $clickMenuColor;
                    opacity: 1;
                }

                .v-list-item--link:before {
                    background-color: transparent;
                }

                .v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
                    margin-right: 20px;
                }

                div.v-list-group__items div.v-list-item__icon {
                    margin-left: 5px !important;
                }

                div.ml-n4 {
                    margin-left: 0px !important;
                }
            }

            .user {
                border-radius: 20px !important;
            }

        }
    }

    /*.v-content .v-content__wrap {*/
    /*    margin-left: 4px !important;*/
    /*}*/
</style>
